module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Description","howCanYou":"How can you implement this measure?","howDidOthers":"How did other companies implement this measure?"},"de":{"description":"Beschreibung","howCanYou":"Wie können Sie diese Maßnahme umsetzen?","howDidOthers":"Wie haben andere Unternehmen diese Maßnahme umgesetzt?"}}')
  delete Component.options._Ctor
}
